module.exports = __webpack_public_path__ + "assets/images/office_desc.16126fe8e457917852547b5d5293a291.png";